import React from "react";
import TextInput from "./TextInput";

export default function ({
  label,
  name,
  register,
  errorMessage = "",
  classes = "",
  parentClasses = "",
  labelClasses = "",
  required = false
}) {
  return (
    <TextInput
      label={label}
      classes={classes}
      parentClasses={parentClasses}
      labelClasses={labelClasses}
      name={name}
      register={register}
      errorMessage={errorMessage}
      type="date"
      required={required}
    />
  );
}